import {  Document, Font, Image, Page, PDFViewer, StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { Component, Fragment } from "react";
import { Button } from "react-bootstrap";
import i18n from "../../../../i18n";

Font.register({
    family: 'Times-Roman',
    fonts: [
        { src: 'assets/fonts/times.ttf', fontWeight: 400 },
        { src: 'assets/fonts/timesbd.ttf', fontWeight: 900 }
    ]
});
const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    page: {
        marginTop: '10px'
    },
    logo: {
        width: 80,
        height: 80,
    },
    body: {
        // paddingTop: "10px",
        // border:'1px',
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingBottom: "20px",
    },
    row: {
        flex: 1,
        flexDirection: 'row',
    },
    rowHeader: {
        flex: 1,
        flexDirection: 'row',
    },
    col: {
        flex: 1,
        flexDirection: 'column',
    },
    colBorder: {
        flex: 1,
        borderLeft: 1,
        flexDirection: 'column',
    },
    block: {
        flexGrow: 1,
    },
    tr: {
        borderBottom: '1px',
        flexDirection: 'row',
    },
    trHeader: {
        backgroundColor: "#CCFFCC",
        // borderBottom: '1px',
        flexDirection: 'row',
    },
    td: {
        // borderRight: '1px',
        borderLeft: '1px',
        flexDirection: 'column',
        flexWrap: "wrap",
        // whiteSpace: "-moz-pre-wrap", /*Firefox */    
        // whiteSpace: "-pre-wrap",     /* Opera <7 */   
        // whiteSpace: "-o-pre-wrap",   /* Opera 7 */    
        // wordWrap: "break-word",       /* CSS3 */   
        overflowWrap: "break-word"

    },
    tdcol: {
        colspan: '2',
        flexDirection: 'column',
    },

    //Header
    titleContainer: {
        flexDirection: 'row',
    },
    titleHeader: {
        flexDirection: 'row',
        marginBottom: '10px'
    },
    header: {
        fontSize: "18px",
        fontFamily: 'Times-Roman'
    },
    address: {
        fontSize: "12px",
        fontFamily: 'Times-Roman'
    },

    titleTranx: {
        fontSize: "12px",
        fontWeight: 700,
        fontFamily: 'Times-Bold',
        textAlign: 'left',
        marginBottom: '5px'
    },
    title: {
        fontSize: "15px",
        fontWeight: 700,
        fontFamily: 'Times-Bold',
        textAlign: 'center',
        marginBottom: '5px'
    },

    div: {
        width: '100%',
        height: 400,
        border: '1 solid black'
        // fontSize: "15px",
        // fontWeight: 700,
        // fontFamily: 'Times-Bold',
        // textAlign: 'center',
        // marginBottom:'5px'
    },

    tableTitle: {
        borderTop: '1px solid black',
        fontSize: "12px",
        fontWeight: 400,
        fontFamily: 'Times-Roman',
        // padding: '5px',
    },

    tableTotal: {
        fontSize: "12px",
        fontFamily: 'Times-Roman',
        padding: '5px',
        marginTop: '2px'
    },
    //End Header
    //Table Item
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 24,
        borderWidth: 1,
        borderColor: '#bff0fd',
        fontSize: "12px",
        fontWeight: 400,
        fontFamily: 'Times-Roman',
        border: '2px'
    },

    tableName: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        textAlign: 'center',
        fontSize: "12px",
        fontWeight: 400,
        borderRight: 1,
        borderBottom: 1,
        fontFamily: 'Times-Roman',
    },
    //Dalam Table
    menuHeader: {
        textAlign: 'center',
        fontFamily: 'Times-Bold',
        fontSize: "12px",
    },

    totalBottom: {
        textAlign: 'right',
        fontFamily: 'Times-Bold',
        paddingRight: '1px',
        paddingTop: '2px',
        fontSize: "8px",
    },


    fillText: {
        textAlign: 'left',
        paddingLeft: '1px',
        fontSize: "9px",
        paddingTop: '1px',
        // display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },

    fillDate: {
        textAlign: 'center',
        paddingLeft: '1px',
        fontSize: "9px",
        paddingTop: '1px',
        // display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },

    fillTextType: {
        textAlign: 'center',
        paddingLeft: '1px',
        fontSize: "10px",
        fontFamily: 'Times-Bold',
    },

    fill: {
        textAlign: 'left',
        paddingLeft: '5px',
        fontSize: "10px",
        fontFamily: 'Times-Bold',
    },

    fillNo: {
        textAlign: 'center',
        fontSize: "9px",
    },

    fillNumber: {
        textAlign: 'right',
        paddingRight: '2px',
        fontSize: "9px",
    },

    fillNumberBold: {
        textAlign: 'right',
        paddingRight: '2px',
        fontSize: "9px",
        fontFamily: 'Times-Bold',
    },

    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 10,
        top: 100,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },

    //end Table

    //Footer
    footer: {
        position: 'absolute',
        bottom: 0
    }
    //end Footer
});
const tableRowsCount = 11;
class PriceComparisonSellingPDF extends Component{
    constructor(props){
        super(props)
        this.state={
            title:i18n.t("Laporan Perbandingan Harga Jual"),
            merchant:{
                email: null,
                fax: null,
                logo: '/assets/media/logos/logo.jpg',
                name: "CV. CELEBES PUTERA SEJAHTERA",
                phone: null,
                website: null,
                address:[]
            },
            logo:'/assets/media/logos/logo.jpg',
            in:[],
            out:[],
        };
    }
    renderMessage(){
        const {isProcessing, requestPrint}=this.props
        switch(true){
            case isProcessing:
                return (
                <div style={loader}>
                    <div className="spinner-border text-primary" style={{width: '10rem', height: '10rem'}} role="status"></div><br/>
                    <div style={{fontSize:36}}>Getting Data From Server</div>
                </div>)
            case requestPrint:
                return (
                    <div style={loader}>
                        {/* <div className="spinner-border text-primary" style={{width: '10rem', height: '10rem'}} role="status"></div><br/> */}
                        <div style={{fontSize:36}}>Please Wait Response from Head Office </div>
                        <div><Button variant="primary" onClick={()=>{this.props.getPrint(this.props.id)}}>Reload Page</Button></div>
                    </div>)
        }
    }

    renderMenu(){
        html.push(
           
        );
        return html;
    }
    render(){
        const {dataPrint}=this.props
        let totalDebt = 0;
        let totalCredit = 0;
        let address=[]
        if(dataPrint!=null){
            this.state.data=dataPrint.data
            this.state.merchant=dataPrint.merchant
            address=this.state.merchant.address.split(/\r?\n/)
          
    }
        
        return(
            <React.Fragment>{(dataPrint !=null)?
                <PDFViewer width={"100%"} height={"100%"} >
                    <Document title={this.state.title}>
                        <Page wrap size={"A4"} style={styles.page}>
                            <View style={styles.body}>
                                <View style={styles.titleContainer}>
                                    <View style={styles.row}>
                                        <View style={styles.col,{width:'90px'}} >
                                            <Image src={(this.state.merchant.logo!=null)?this.state.merchant.logo:"/assets/media/logos/logo.jpg"} style={styles.logo} />
                                        </View>
                                        <View style={styles.col,{width:'300px'}} >
                                            <Text style={styles.header}>{this.state.merchant.name}</Text>
                                            {address.map((a,i)=>
                                                <Text key={'add'+i} style={styles.address} wrap={false}>{a}</Text>
                                            )}
                                        </View>
                                    </View>
                                </View>
                                <View style={styles.titleContainer}>
                                    <View style={styles.row}>
                                        <View style={styles.col} >
                                            <View style={styles.title}>
                                                <Text>{i18n.t("Laporan Perbandingan Harga Jual")}</Text>
                                            </View>
                                            <View style={styles.title}>
                                                <Text>{dataPrint.data.name}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                 <View style={[styles.titleContainer,{marginTop:'10px'}]}>
                                    <View fixed style={styles.tableTitle}  >
                                        <View style={styles.trHeader}>
                                            <Fragment key={'menuHeader'}>
                                                {/* <View style={[styles.td,{width:'5%'}]}>
                                                    <Text style={styles.menuHeader}>{"No"}</Text>
                                                </View> */}
                                                <View style={[styles.td,{width:'13%'}]}>
                                                    <Text style={styles.menuHeader}>{"ASMO"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'17%'}]}>
                                                    <Text style={styles.menuHeader}>{"Kode Barang"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'10%'}]}>
                                                    <Text style={styles.menuHeader}>{"Merk"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'10%'}]}>
                                                    <Text style={styles.menuHeader}>{"Kategori"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'23%'}]}>
                                                    <Text style={styles.menuHeader}>{"Nama Barang"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'7%'}]}>
                                                    <Text style={styles.menuHeader}>{"Satuan"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'10%'}]}>
                                                    <Text style={styles.menuHeader}>{"Harga Jual"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'10%',borderRight:'1px'}]}>
                                                    <Text style={styles.menuHeader}>{"Tanggal Efektif"}</Text>
                                                </View>
                                            </Fragment>
                                        </View>
                                    </View>
                                </View>
                               
                               
                                <View style={styles.titleContainer}>
                                    <View  style={styles.tableTitle}>
                                    {dataPrint.data.map((data,i)=>
                                        data.item.length > 0? 
                                            data.item.map((item,p)=>
                                                <View style={styles.tr} key={'detail' + p}>
                                                    <Fragment key={'detail' + p}>
                                                        {/* <View style={[styles.td,{width:'3%'}]}>
                                                            <Text style={styles.fillNo}>{p+1}</Text>
                                                        </View> */}
                                                        <View style={[styles.td,{width:'13%'}]}>
                                                            <Text style={styles.fillText}>{data.name}</Text>
                                                        </View>
                                                        <View style={[styles.td,{width:'17%'}]}>
                                                            <Text style={styles.fillText}>{item.code}</Text>
                                                        </View>
                                                        <View style={[styles.td,{width:'10%'}]}>
                                                            <Text style={styles.fillText}>{item.brand}</Text>
                                                        </View>
                                                        <View style={[styles.td,{width:'10%'}]}>
                                                            <Text style={styles.fillText}>{item.category}</Text>
                                                        </View>
                                                        <View style={[styles.td,{width:'23%'}]}>
                                                            <Text style={styles.fillText}>{item.name_item}</Text>
                                                        </View>
                                                        <View style={[styles.td,{width:'7%'}]}>
                                                            <Text style={styles.fillText}>{item.unit}</Text>
                                                        </View>
                                                        <View style={[styles.td,{width:'10%'}]}>
                                                            <Text style={[styles.fillText, {textAlign:'right', paddingRight:'2px'}]}>{item.price_format}</Text>
                                                        </View>
                                                        <View style={[styles.td,{width:'10%',borderRight:'1px'}]}>
                                                            <Text style={styles.fillDate}>{item.date_pdf}</Text>
                                                        </View>
                                                    </Fragment>
                                                </View>
                                            )
                                        :null     
                                    )}
                                        {/* <View style={styles.tr}>
                                            <Fragment key={'jumlah'}>
                                                <View style={[styles.td,{width:'60%'}]}>
                                                    <Text style={styles.menuHeader}>{"Total"}</Text>
                                                </View>
                                                <View style={[styles.td,{width:'12%'}]}>
                                                    <Text style={styles.fillNumberBold}>{totalDebt < 0 ?
                                                                '(' + (totalDebt * (-1)).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + ')' :
                                                                totalDebt.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                                            }</Text>
                                                </View>
                                                <View style={[styles.td,{width:'12%'}]}>
                                                    <Text style={styles.fillNumberBold}>{totalCredit < 0 ?
                                                                '(' + (totalCredit * (-1)).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + ')' :
                                                                totalCredit.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                                            }</Text>
                                                </View>
                                                <View style={[styles.td,{width:'16%',borderRight:'1px'}]}>
                                                    <Text style={styles.menuHeader}></Text>
                                                </View>
                                            </Fragment>
                                        </View> */}
                                    </View>
                                </View>
                                
                            </View>
                        </Page>
                    </Document>
            </PDFViewer>
            :
            this.renderMessage()}
            
        </React.Fragment>   
        
        )
    }
}

export default PriceComparisonSellingPDF;

const loader={
    alignItems: 'center',
    background: '#FFF',
    display: 'flex',
    flexDirection:'column',
    height: '100vh',
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    top: 0,
    transition: 'opacity 0.2s linear',
    width: '100%',
    opacity: 1,
    transform: 'opacity 1s linear',
}